import { FormControl, FormGroup } from '@angular/forms';
import { ControlsOf } from '../controls-of.form-group';
import { endAfterStartValidator } from './slot.validators';

export interface Slot {
  startTime: string | null; // "08:30"
  endTime: string | null; // "12:00"
}

export type SlotFormGroup = FormGroup<ControlsOf<Slot>>;

export function createSlotFormGroup(slot: Slot): SlotFormGroup {
  return new FormGroup<ControlsOf<Slot>>(
    {
      startTime: new FormControl(slot.startTime, { nonNullable: true }),
      endTime: new FormControl(slot.endTime, { nonNullable: true }),
    },
    { validators: endAfterStartValidator() },
  );
}
